import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  makeStyles,
  tokens,
  Text,
  TabList,
  Tab,
  Spinner,
  Avatar,
  type SelectTabData,
  type SelectTabEvent,
} from "@fluentui/react-components";
import { useAuth } from "../auth/TeamsAuthProvider";
import TicketList from "../components/TicketList";
import { useTickets } from "../hooks/useTickets";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    backgroundColor: tokens.colorNeutralBackground2,
  },
  header: {
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalL}`,
    borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
    backgroundColor: tokens.colorNeutralBackground1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
  },
  tabs: {
    padding: `0 ${tokens.spacingHorizontalL}`,
    backgroundColor: tokens.colorNeutralBackground1,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  content: {
    flex: 1,
    overflow: "auto",
  },
  spinnerWrap: {
    display: "flex",
    justifyContent: "center",
    padding: tokens.spacingVerticalXXL,
  },
});

type TabKey = "mine" | "all";

export default function InboxPage() {
  const styles = useStyles();
  const { token, workspaceId, agent } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<TabKey>("mine");

  const params =
    activeTab === "mine"
      ? { excludeClosedResolved: true, assignedToId: agent.id }
      : { excludeClosedResolved: true };

  const { tickets, loading } = useTickets(token, workspaceId, params);

  function onTabSelect(_: SelectTabEvent, data: SelectTabData) {
    setActiveTab(data.value as TabKey);
  }

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <Text size={500} weight="semibold">Enque</Text>
        </div>
        <Avatar name={agent.displayName} size={28} />
      </div>

      <div className={styles.tabs}>
        <TabList selectedValue={activeTab} onTabSelect={onTabSelect}>
          <Tab value="mine">My Tickets</Tab>
          <Tab value="all">All Open</Tab>
        </TabList>
      </div>

      <div className={styles.content}>
        {loading ? (
          <div className={styles.spinnerWrap}>
            <Spinner />
          </div>
        ) : (
          <TicketList
            tickets={tickets}
            onSelect={(t) => navigate(`/ticket/${t.id}`)}
          />
        )}
      </div>
    </div>
  );
}
